/** Default page size for action tables */
export const ACTION_TABLE_PAGE_SIZE = 10;
